import "./App.css";
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import DynamicPage from "./pages/DynamicPage";
const AdminPage = lazy(() => import('./pages/AdminPage'));
const TemplatePreviewPage = lazy(() => import('./pages/TemplatePreviewPage'));
import { Toaster } from "./components/ui/toaster";
import ThemeApplier from "./components/ThemeApplier";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { installAxiosAuthInterceptor } from "./utils/axiosSetup";
import { SeoManager } from './components/public/SeoManager';

installAxiosAuthInterceptor();

function App() {
  return (
    <div className="App">
      <ThemeApplier />
      <BrowserRouter>
        <AnalyticsTracker />
        <SeoManager />
        <Suspense fallback={<div role="status" data-testid="route-loading" className="p-8 text-center">Načítání…</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/preview/template/:templateId" element={<TemplatePreviewPage />} />
          <Route path="/:slug" element={<DynamicPage />} />
          <Route path="*" element={<DynamicPage />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;